<template>
  <div>
    <div v-if="show">
      <div class="agency-top">
        <img src="../../assets/images/bg_02.jpg" class="img" />
        <div class="data-m-t">
          <span>总数：{{ codeData.sum_count }}</span>
          <span>已用：{{ codeData.use_count }}</span>
          <span>剩余：{{ codeData.remain_count }}</span>
          <div class="van-hairline--top"></div>
          <span>绀发：{{ codeData.gf_sum_count }}</span>
          <span>已用：{{ codeData.gf_use_count }}</span>
          <span>剩余：{{ codeData.gf_remain_count }}</span>
          <div class="van-hairline--top"></div>
          <span>沃隆：{{ codeData.wl_sum_count }}</span>
          <span>已用：{{ codeData.wl_use_count }}</span>
          <span>剩余：{{ codeData.wl_remain_count }}</span>
        </div>
      </div>

      <van-cell v-for="(item, k) in list" :key="item.id" :title="item.code" :value="item.status_name" />

    </div>


    <Footer />
    <Laod ref="laoding" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Tab, Tabs, Cell, CellGroup } from 'vant'
  export default {
    components: {
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
    },
    name: 'retails',
    data() {
      return {
        active: 0,
        show: false,
        codeData: [],
        list: []
      }
    },
    created() {
     this.getData()
    },
    methods: {
      getData() {
        this.$api.get('fw/codeList', {id: localStorage.getItem('uid')}, r=>{
          this.codeData = r.result
          this.list = r.result.list.data
          this.list.map((item) => {
            item.status_name = '未使用'
            if(item.status == 1){
              item.status_name = '已使用'
            }
            return item
          })
          this.show = true
          this.$refs.laoding.loadClose()
        })
      },
    }
  }
</script>

<style scoped>
  .data-m-t{
    position: absolute;
    top: 8%;
    left: 5%;
    width: 90%;
    color:#fff;
    text-align: center;
    font-size: 15px;
  }
  .data-m-t span{
    display: inline-block;
    line-height: 30px;
    width: 32%;
    text-align: left;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/data/index.vue